<script>
import { defineComponent, computed } from 'vue'
import { scaleLinear } from 'd3'

export default defineComponent({
  props: {
    colors: {
        type: Array,
        default: () => []
    },
    levels: {
        type: [Array, Number],
        default: () => []
    },
    yScale: {
        type: Function,
        required: true,
    },
    width: {
        type: Number,
        default: 0
    },
    height: {
        type: Number,
        default: 0
    },
    ranks: {
        type: [Number],
        default: 0
    },
  },
  setup (props) {
    const ticks = computed(() => props.yScale.ticks ? props.yScale.ticks() : [])
    const sections = computed(() => scaleLinear()
        .domain([0, props.ranks * 10])
        .ticks(props.ranks)
        .reduce((acc, tick, rank) => {
            if (tick) {
                const y = props.yScale(tick) || 0
                acc.push({
                    showLine: y > 0,
                    rank,
                    y,
                })
            }
            return acc
        }, [])
    )
    const rects = computed(() =>
      ticks.value.reduce((acc, tick) => {
        const y = props.yScale(tick) || 0
        if (y >= 0) {
          const h = props.height / (ticks.value.length -1)
          const c = props.colors[(tick - 1 < 1 ? 1 : tick - 1).toFixed(0)]
          acc.push({ y, h, c, tick })
        }
        return acc
      }, [])
    )

    return {
        rects,
        sections,
    }
  }
})
</script>

<template>
    <g class="ranks">
        <g v-for="({ showLine, rank, y }) of sections" :key="`rank-${rank}`" :transform="`translate(0, ${y})`" style="opacity: 0.8">
            <text x="20" dy="6%" style="font-style: italic; font-size: 12; font-weight: 400; opacity: 0.7">
              {{ rank }} rank
            </text>
            <line v-if="showLine" :x2="width - 25" stroke="black" stroke-dasharray="2,2" />
        </g>

        <g v-for="({ y, h, c }, i) of rects" :key="`area-${i}`" :transform="`translate(0, ${y})`">
            <rect v-if="i" :width="width" :height="h" :fill="c || 'currentColor'" opacity="0.2" />
        </g>
    </g>
</template>
